import ConstantRouterComponents from "./routeMapping";
import { filterRouterCustomField, getCustomField } from "@/utils/util";
import { rootRouter } from "./rootRouter";
import { BasicLayout, EmptyLayout } from "@/layouts";

/**
 * 动态生成菜单
 * @param token
 * @returns {Promise<Router>}
 */
export const processDynamicRouter = (originRoutes) => {
  transformRootToMenu(rootRouter);
  const menuNav = [rootRouter, ...originRoutes];
  const routeMap = generator(menuNav);
  processRouteMapPage(routeMap);
  addRouterPosition(routeMap);
  transsformVirtualRouter(routeMap);
  console.log(routeMap);
  return routeMap;
};

function processRouteMapPage(routeMap) {
  // 将首层页面混入到main下面去
  const rootRoute = routeMap[0];
  for (let i = 0; i < routeMap.length; i++) {
    const route = routeMap[i];
    const isPageMenu = Boolean(!route.children && route.meta.isShow);
    if (isPageMenu) {
      if (!rootRoute.children) {
        rootRoute.children = [{ ...route, name: `${route.name}$` }];
      } else {
        rootRoute.children.push({ ...route, name: `${route.name}$` });
      }
    }
  }
}
// 给Router增加路径
function transformRouterPath(item) {
  const currentPath = item.meta.position;
  if (item.children) {
    for (let i = 0; i < item.children.length; i++) {
      const el = item.children[i];
      el.meta.position = [...currentPath, "children", i];
      transformRouterPath(el);
    }
  }
}

function addRouterPosition(mapRoutes) {
  for (let i = 0; i < mapRoutes.length; i++) {
    const el = mapRoutes[i];
    el.meta.position = [i];
    transformRouterPath(el, true);
  }
}

// 将iframe转换为虚拟路由
function transsformVirtualRouter(routeMap) {
  const isRootRouter = (router) => router.path === "/";
  const rootRouter = routeMap.find((el) => el.path === "/");
  const isFirstFloorRouter = (route) =>
    route.component === undefined &&
    route.meta.position &&
    route.meta.position.length === 1
      ? true
      : false;
  const isOtherRouter = (route) =>
    route.meta.position && route.meta.position.length > 1 ? true : false;
  for (let i = 0; i < routeMap.length; i++) {
    const el = routeMap[i];
    if (el.children && el.children.length >= 1) {
      if (isFirstFloorRouter(el)) {
        el["component"] = BasicLayout;
      } else if (isOtherRouter(el)) {
        // 其他层级的路由组件应该为空layout
        el["component"] = EmptyLayout;
      }
      transsformVirtualRouter(el.children);
    } else {
      if (!isRootRouter(el)) {
        if (el.meta["iframePath"]) {
          el["component"] = ConstantRouterComponents["iframe"];
          if (rootRouter && el.meta.position.length === 1 && el.meta.isShow) {
            const currentRouter = rootRouter.children.find(
              (routerItem) => routerItem.path === el.path
            );
            currentRouter["component"] = ConstantRouterComponents["iframe"];
          }
        } else {
          // 没有配置iframePath被认为是普通页面,暂时不做处理
          if (ConstantRouterComponents[el.meta["name"]]) {
            console.log(el);
          }
        }
      }
    }
  }
}

function transformRootToMenu(rootRouter) {
  rootRouter.customField = JSON.stringify(rootRouter.meta);
  delete rootRouter.meta;
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map((item) => {
    const { isRoot } = item;
    // const isCustomField = Boolean(item.customField);
    let customField = {};
    // if (isCustomField) {
    // customField = filterRouterCustomField(item.customField);
    customField = getCustomField(item);
    // }
    let currentRouter = {
      /**
       * /name/name
       */
      path: isRoot
        ? "/"
        : `${(parent && parent.path) || ""}/${customField.name}`,
      name: customField.name,
      component:
        ConstantRouterComponents[isRoot ? item.component : customField.name],
      meta: {
        ...customField,
        menuId: item["id"],
      },
      redirect: item.redirect || "",
    };
    if (currentRouter["component"] === undefined) {
      delete currentRouter.component;
      delete currentRouter.redirect;
    }
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter);
    }
    return currentRouter;
  });
};
